import { Component, OnInit, Inject, ViewEncapsulation } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  throwMatDialogContentAlreadyAttachedError
} from "@angular/material";
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthService } from "../../core/auth/auth.service";
import { UserService } from "../../core/user.service";
import { AlertService } from "../../_services/index";

@Component({
  selector: "app-cqmns-project-popup",
  templateUrl: "./cqmns-project-popup.component.html",
  styleUrls: ["./cqmns-project-popup.component.css"],
  encapsulation: ViewEncapsulation.None
})
export class CqmnsProjectPopupComponent implements OnInit {
  hostUrl;
  projects : any;
  project : any;
  userId: any;
  userRole: any;
  searchString:string;
  userName: any;
  closeFlg= true;
  constructor(
    private alertService: AlertService,
    private http: HttpClient,
    private router: Router,
    private authService: AuthService,
    private userService: UserService,
    private dialogRef: MatDialogRef<CqmnsProjectPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: String
  ) {}

  ngOnInit() {
    this.hostUrl = this.userService.getUrl();
    this.userRole = localStorage.getItem("CurrentRole");
    this.userId = localStorage.getItem("userid");
    this.userName = localStorage.getItem("name");
    if (localStorage.getItem('projectId')) {
      this.closeFlg = false;
    }
   // this.authService.user().subscribe(data => {
      // this.addUser(data);
      //Portfolio Head
      this.http.get(encodeURI(this.hostUrl + '/api/issue/qab/allProjects/' + this.userId))
      .subscribe(data => {
          this.projects = data;
      });
    //});
  }
  // addUser(data) {
  //   this.userId = data.user_id;
  // }
   selectedProject(project) {       
        localStorage.setItem('projectId', project.project_id);
        localStorage.setItem('cqm-project-name', project.project_name);  
        this.dialogRef.close();
        // const url ='/cqm-ns/' + projectId;
        // this.router.navigate([url]);
        this.router.navigate([this.router.url]);

    }
    closePopup(){
      this.dialogRef.close();
    }
}



// WEBPACK FOOTER //
// ./src/app/_models/cqmns-project-popup/cqmns-project-popup.component.ts